// @ts-strict-ignore
import { FC } from 'react'

import cl from './TableBlock.module.scss'
import { TableItem } from './TableItem/TableItem'

import { gridInfoProps } from './styles'

export const TableBlock: FC<gridInfoProps> = ({ title, gridList }) => (
	<section className={cl.section}>
		<h2 className={cl.title}>{title}</h2>
		<ul className={cl.list}>
			{gridList.map((item, index) => (
				<li key={index + 'gridList'} className={cl.item}>
					<TableItem {...item} />
				</li>
			))}
		</ul>
	</section>
)
